var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusPassedInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "passed_inactive_40px",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)",
    fill: "#8F9BBD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0 C31.045695,0 40,8.954305 40,20 C40,31.045695 31.045695,40 20,40 C8.954305,40 0,31.045695 0,20 C0,8.954305 8.954305,0 20,0 Z M20,1 C9.50658975,1 1,9.50658975 1,20 C1,30.4934102 9.50658975,39 20,39 C30.4934102,39 39,30.4934102 39,20 C39,9.50658975 30.4934102,1 20,1 Z",
    id: "Oval-Copy-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5148882,10.601814 C19.3607238,9.78160988 20.7113158,9.80238822 21.5315199,10.6482237 C22.3085554,11.4495416 22.3308033,12.7038819 21.6118044,13.5310927 L21.4851102,13.6648554 L17.1978662,17.8218675 L27.3517763,27.668479 C28.1530941,28.4455145 28.2139175,29.6985768 27.5207054,30.5475139 L27.398186,30.6851107 C26.6211505,31.4864285 25.3680882,31.5472518 24.519151,30.8540398 L24.3815543,30.7315204 L12.6482222,19.3537437 C11.8271408,18.5575436 11.7860867,17.266119 12.5250599,16.4203964 L12.6482222,16.2907023 L18.5148882,10.601814 Z",
    id: "Path-21-Copy",
    transform: "translate(20.000000, 20.666667) rotate(-90.000000) translate(-20.000000, -20.666667) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusPassedInactive);
export default __webpack_public_path__ + "static/media/status-passed-inactive.e968c857e7a2aab218c638b9963a6f49.svg";
export { ForwardRef as ReactComponent };